module.exports = __webpack_public_path__ + "media/images/img/seikousya/teracesky-9e7e415ba83bbf1f060d14da2d9acf7c.png";